import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import './JoinClub.css';

export interface IJoinClubProps {
    image_path: string;
    data?: any;
}

export const JoinClub = (props: IJoinClubProps) => (
    <div style={{ backgroundColor: '#f05471', marginTop: 80 }} className='JoinClubContainer'>
        <Container style={{ padding: 0 }}>
            <img src={props.image_path + props.data.header} className='JoinClubHeader' />
            <Row className='JoinClubBody'>
                <Col xs={12} lg={9}>
                    <Row>
                        <Col md={6}>
                            <img src={props.image_path + props.data.left} className='JoinClubLeft' />
                        </Col>
                        <Col md={6}>
                            <img src={props.image_path + props.data.right} className='JoinClubRight' />
                        </Col>
                    </Row>
                    <p className='JoinClubRemark' dangerouslySetInnerHTML={{ __html: props.data.remark }} />
                    <p className='JoinClubDownload'>
                        <img src={props.image_path + props.data.searchbar} className='JoinClubDownloadImage' />
                        {props.data.download}
                    </p>
                </Col>
                <Col xs={12} lg={3}>
                    <img src={props.image_path + props.data.take_action} className='JoinClubTakeAction' />
                    <div className='JoinClubStoreContainer d-flex flex-column justify-content-center' style={{ textAlign: 'center' }}>
                        <Row>
                            <Col xs={12} sm={6} lg={12}>
                                <a href={props.data.app_store.url} target='_blank'>
                                    <img src={props.image_path + props.data.app_store.image} className='JoinClubAppStore' />
                                </a>
                            </Col>
                            <Col xs={12} sm={6} lg={12}>
                                <a href={props.data.google_play.url} target='_blank'>
                                    <img src={props.image_path + props.data.google_play.image} className='JoinClubGooglePlay' />
                                </a>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
);


// WEBPACK FOOTER //
// ./src/pages/Home/JoinClub/index.tsx